import { authApi } from '../api'

const useDeeplink = () => {
  const loadDeeplink = async () => {
    try {
      const deeplink = await authApi.loadDeeplink()
      return deeplink
    } catch (error) {
      console.error('Failed to load deeplink', error)
      return null
    }
  }

  return { loadDeeplink }
}

export default useDeeplink
